
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fedex-luggage-shipping",
      function () {
        return require("private-next-pages/fedex-luggage-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fedex-luggage-shipping"])
      });
    }
  